export default __webpack_public_path__ + "static/angkasatu-bb6ca1543acb6c988be3ecfdcf7c99f9.png";